<template>
  <Loading v-if="!skeleton.productLoaded" page="product" />
  <div
    v-show="skeleton.productLoaded"
    :class="{ 'fade-in': skeleton.productLoaded }"
  >
    <header-middle />
    <bread-crumb
      v-if="productDetail"
      :vector="[
        {
          fa: `فروشگاه ${productDetail.store_place_name}`,
          path: `/Store/${productDetail.store_place_id}`,
        },
        {
          fa: `${productDetail.ordination_fa}`,
          path: `/Category/ordinant/${productDetail.ordination}/${productDetail.store_place_id}`,
        },
        {
          fa: `${productDetail.stuff_name}`,
          path: `/Product/${productDetail.id}`,
        },
      ]"
    />
    <div class="banner-bootom-w3-agileits">
      <div class="container-fluid">
        <product-template :productDetail="productDetail" v-if="productDetail" />
        <related-product
          :ordination_id="productDetail.ordination"
          :item_id="productDetail.id"
          v-if="productDetail"
        />
      </div>
      <survay-template :stuff_id="productDetail.id" v-if="productDetail" />
    </div>
    <footer-template />
  </div>
</template>

<script setup>
import HeaderMiddle from "../section/header/header.vue";
import FooterTemplate from "../section/footer/footer.vue";
import BreadCrumb from "../section/item/BreadCrumb.vue";
import ProductTemplate from "../section/pages/Single/product.vue";
import SurvayTemplate from "../section/pages/Single/survay.vue";
import RelatedProduct from "../section/pages/Single/related.vue";
import Loading from "../section/item/loading.vue";
import { ref, computed, watch } from "vue";
import { useRoute } from "vue-router";
let productDetail = ref();
const route = useRoute();
import { useSkeleton } from "@/store/skeleton";
const skeleton = useSkeleton();
const product_id = computed(() => route.params.item || 1);
watch(
  product_id,
  () => {
    showProduct().then((data) => {
      productDetail.value = data;
      skeleton.product = true;
    });
  },
  { immediate: true }
);
async function showProduct() {
  skeleton.product = false;
  let request = await fetch(
    "https://radap.ir/Backend/api/section/pages/product/get.php?id=" +
      product_id.value
  );
  let response = await request.json();
  return response;
}
</script>

<style></style>
